export default {
  // ASPICE 过程名称 - 工作成果菜单
  'menu.process.MAN.3': 'MAN.3 项目管理',
  'menu.process.FSC': 'FSC 功能安全概念',
  'menu.process.CSC': 'CSC 网络安全概念',
  'menu.process.SYS.2': 'SYS.2 系统需求分析',
  'menu.process.SYS.3': 'SYS.3 系统架构设计',
  'menu.process.SWE.1': 'SWE.1 软件需求分析',
  'menu.process.SWE.2': 'SWE.2 软件架构设计',
  'menu.process.SWE.3': 'SWE.3 软件详细设计和单元构建',
  'menu.process.SWE.4': 'SWE.4 软件单元验证',
  'menu.process.SWE.5': 'SWE.5 软件组件验证和集成验证',
  'menu.process.SWE.6': 'SWE.6 软件验证',
  'menu.process.HWE.1': 'HWE.1 硬件需求分析',
  'menu.process.HWE.2': 'HWE.2 硬件设计',
  'menu.process.HWE.3': 'HWE.3 硬件设计验证',
  'menu.process.HWE.4': 'HWE.4 硬件需求验证',
  'menu.process.SYS.4': 'SYS.4 系统集成和集成验证',
  'menu.process.SYS.5': 'SYS.5 系统验证',
  'menu.process.SUP.1': 'SUP.1 质量保证',
  'menu.process.SUP.8': 'SUP.8 配置管理',
  'menu.process.SUP.9': 'SUP.9 问题解决',
  'menu.process.ACQ.4': 'ACQ.4 供应商管理',
  'menu.process.SUP.10': 'SUP.10 变更管理',
  'menu.process.SVV.1': 'SVV.1 软件验证与确认',
  'menu.process.SVV.2': 'SVV.2 软件确认',
  'menu.process.SPL.2': 'SPL.2 产品发布',
  'menu.process.TMG.1': 'TMG.1 工具管理',
};
